import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ReadOnlyType, UomSetProps } from 'app/area/codetable/item/types';
import { createUomSetFieldId, getUomSetValidation } from 'app/area/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const IndicatorSetUomType = (props: UomSetProps) => {

  const {
    substanceUomSetValue: { uomTypeIndicator, uomSet: { value: currentUomSetValue = undefined } = {} },
    breadcrumbs, codeItem: { substanceUomSet } = {}, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig } = props;

  const fieldId = createUomSetFieldId(ScreenPicker.uomSetIndicatorValueType, currentUomSetValue);
  const uomSetIndicatorValueFieldId = createUomSetFieldId(ScreenPicker.uomSetIndicatorValue, currentUomSetValue);
  const codetableId = codetableOptionsIds[ScreenPicker.uomSetIndicatorValueType];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(fieldId);
    resetValidation(uomSetIndicatorValueFieldId);
    currentUomSetValue && updateByKey(ScreenPicker.substanceUomSet, substanceUomSet.map(item => item.uomSet.value === currentUomSetValue
      ? {
        ...item,
        [ScreenPicker.uomSetIndicatorValueType]: value,
        [ScreenPicker.uomSetIndicatorValue]: undefined
      }
      : item));
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, loadOptionsParams);
  };

  const codeOptions = codetableOptions?.[fieldId]?.codes ?? [] as CodeComplexValue<number>[];
  const uomValidation = getUomSetValidation({
    uomSet: currentUomSetValue,
    uomTypeName: ScreenPicker.uomSetIndicatorValueType,
    uomTypeValue: uomTypeIndicator?.value,
    validation: validation[ScreenPicker.substanceUomSet]
  });

  const readOnly = (readOnlyConfig && readOnlyConfig[ReadOnlyType.all]);

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  return <CodeSinglePicker
    id={fieldId}
    label={translation.default_uom_type}
    valueItem={uomTypeIndicator}
    searchRequired={false}
    required={false}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={!!codetableOptions && codetableOptions[fieldId] && codetableOptions[fieldId].fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={uomValidation}
  />;
};
